import React from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

// ✅ Register modules
ModuleRegistry.registerModules([AllCommunityModule]);

const ActionButton = (props) => {
  const handleClick = () => {
    console.log("Row:", props.data);
  };

  return (
    <button className="btn" onClick={handleClick}>
      <i className="fa fa-edit" aria-hidden="true"></i>
    </button>
  );
};

class dataTable extends React.Component {
  state = {
    rowData: [
      {
        hcpcs: "A1234",
        policy: "Test Policy 1",
        description: "Sample description",
        updated_at: "2024-04-01T10:30:00"
      },
      {
        hcpcs: "B5678",
        policy: "Test Policy 2",
        description: "Another row",
        updated_at: "2024-04-02T12:45:00"
      }
    ],
    columnDefs: [
      {
        headerName: "HCPCS",
        field: "hcpcs",
        resizable: true
      },
      {
        headerName: "Policy",
        field: "policy",
        resizable: true
      },
      {
        headerName: "Description",
        field: "description",
        resizable: true
      },
      {
        headerName: "History",
        field: "updated_at",
        resizable: true,
        valueFormatter: (params) =>
          new Date(params.value).toLocaleString()
      },
      {
        headerName: "Actions",
        field: "actions",
        resizable: false,
        cellRenderer: ActionButton,
      }
    ]
  };

  render() {
    return (
      <div
        className="ag-theme-alpine"
        style={{ height: 500, width: "100%" }}
      >
        <AgGridReact
          rowData={this.state.rowData}
          columnDefs={this.state.columnDefs}
          pagination={true}
        />
      </div>
    );
  }
}

export default dataTable;